import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Typography from 'components/CncUI/Typography';
import completedOffers from 'images/Completed-Offers.png';
import supportingDocuments from 'images/Supporting-Documents.png';

const useStyles = makeStyles(({ spacing }) => ({
  boxSpacing: {
    marginTop: spacing(4),
    marginBottom: spacing(5),
    height: 303,
    width: '100%',
    backgroundColor: '#ffffff',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexDirection: 'column',
  },
  boxBorder: {
    border: '1px dashed #2eaba4',
  },
  completedOffers: {
    backgroundImage: `url(${completedOffers})`,
  },
  supportingDocuments: {
    backgroundImage: `url(${supportingDocuments})`,
  },
  blurb: {
    color: '#2eaba4',
    fontSize: 18,
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: 1.3,
    marginTop: spacing(22),
  },
}));

const EmptyMyFiles = props => {
  const { type = 'completedOffers', border = true, blurb, blurbLine2 } = props;
  const classes = useStyles();
  return (
    <div
      className={classnames({
        [classes.boxSpacing]: true,
        [classes[type]]: true,
        [classes.boxBorder]: border,
      })}
    >
      <Typography className={classes.blurb}>
        {blurb}
        {blurbLine2 && (
          <>
            <br />
            {blurbLine2}
          </>
        )}
      </Typography>
    </div>
  );
};
export default EmptyMyFiles;
